import TIM from 'tim-wx-sdk'
import Service from '@/service'
import PublicService from '@/service/public'
import { formatTime } from '@/utils/index'

import { errorLog, UserLog, sendCtmEvtLog } from '@/utils/log'
import Check from '@/common/utils/check'
import subscribeProperties from '@/common/utils/watchProps'
import { App_User } from '@/data/user_info'
import GlobalData from '@/plugins/global_data'
import {
    MAX_DATETIME_SEGMENT,
    IM_PAGE_SIZE,
    DEFAULT_HEADIMG,
    LOGIN_STATUS,
    PAGE_TO_KEY
} from './constant'

const isProd = process.env.NODE_ENV === 'production'

let userInfo

let tim

export const current_user_data = {
    peer_identifier: '',
    peer_headimgurl: '',
    peer_nickname: '',
    nickname: '',
    headimgurl: ''
}

const BUILDING_STORE = {
    building_id: '',
    from: ''
}

export const setBuildingStore = ({building_id, from}) => {
    BUILDING_STORE.building_id = building_id
    BUILDING_STORE.from = from
}

export const openChat = (id, options) => {
    const goChatPage = () => {
        App_User.get().then((data) => {
            if (data.tag_list[0] == "天府通游客") {
                wx.navigateTo({
                    url: '/logging_in'
                })
            } else {
                const {
                    from,
                    building_id,
                    recommend_aqr_id,
                    is_redirect = false,
                    entrance = '',
                    log_name = '',
                    layout_id = '',
                    auto_send_msg = ''
                } = Object.assign({}, BUILDING_STORE, options)
                UserLog.contactConsultant(id)
                let url = `/chat_list/chat?consultant_id=${id}`
                if (from) {
                    url += `&from=${from}`
                }
                if (building_id) {
                    url += `&building_id=${building_id}`
                }
                if (recommend_aqr_id) {
                    url += `&recommend_aqr_id=${recommend_aqr_id}`
                }
                if (entrance) {
                    url += `&entrance=${entrance}`
                }
                if(layout_id){
                    url += `&layout_id=${layout_id}`
                }
                if(auto_send_msg){
                    url += `&auto_send_msg=${auto_send_msg}`
                }
                wx[is_redirect ? 'redirectTo' : 'navigateTo']({
                    url
                })
                if (log_name) {
                    sendCtmEvtLog(log_name, {
                        building_id
                    })
                }
            }
        })
    }
    wx.navigateTo({
        url: `/consultants/card/main?id=${id}`
    })
}

export const IM_STORE = subscribeProperties({}, [
    {
        key: 'app_show',
        defaultValue: false
    },
    {
        key: 'login',
        defaultValue: LOGIN_STATUS.NONE
    },
    {
        key: 'chatList',
        defaultValue: []
    },
    {
        key: 'chatListLoaded',
        defaultValue: false
    },
    {
        key: 'chatsMap',
        defaultValue: {}
    },
    {
        key: 'no_more',
        defaultValue: false
    },
    {
        key: 'session_loading',
        defaultValue: false
    },
    {
        key: 'page',
        defaultValue: 1
    },
    {
        key: 'login_loading',
        defaultValue: false
    },
    {
        key: 'show_unread',
        defaultValue: false
    }
])

const IM_STATE = {
    session_loading: false,
    sdk_ready: false,
    im_login: false,
    message_changed: false,
    message_changed_timestamp: 0,
    refresh_timestamp: 0,
    loaded_chat_len: 0
}

const retryInit = () => {
    initIM()
    login()
}

const initIM = () => {
    tim = TIM.create({
        SDKAppID: 1400105054
    })
    tim.setLogLevel(isProd ? 1 : 0)
    tim.on(TIM.EVENT.SDK_READY, (res) => {
        console.error(res, 'ready')
        IM_STATE.sdk_ready = true
        IM_STORE.login = LOGIN_STATUS.DONE
        IM_STORE.chatListLoaded = true
    })
    tim.on(TIM.EVENT.SDK_NOT_READY, (res) => {
        console.error(res, 'not ready')
        if (IM_STATE.login && IM_STORE.app_show) {
            errorLog(`IM NOT READY: ${JSON.stringify(res)}`)
        }
        IM_STORE.login = LOGIN_STATUS.NONE
        IM_STATE.sdk_ready = false
        IM_STATE.login = false
        IM_STORE.chatListLoaded = false
        if (IM_STORE.app_show) {
            retryInit()
        }
    })
    listenSessionUpdate()
    initMsgListener()
    tim.on(TIM.EVENT.ERROR, (err) => {
        const { code, message } = err.data
        console.error('im error', code, message)
        if (IM_STATE.login) {
            errorLog(`IM ERROR: ${code}, ${message}`)
        }
    })
}

const handleMessages = (list) => {
    return list.reduce((msgs, msg) => {
        const {
            payload,
            isRead,
            from,
            conversationID,
            ID: id,
            random,
            sequence,
            time,
            isPeerRead
        } = msg
        const ext = msg.type === 'TIMTextElem' || !payload.extension ? {
            msgStyle: 'text',
            data: payload.text
        } : JSON.parse(payload.extension)
        const isSend = msg.flow === 'out'
        const isSendCard = isSend && ext.msgStyle === 'card'
        if (!isSendCard) {
            const headimg = (isSend ? userInfo.headimgurl : ext.headimg) || DEFAULT_HEADIMG
            const mini_headimg = headimg.indexOf('https://cdn.vip-wifi.com') === 0 ? (headimg + '?x-oss-process=image/resize,w_88') : headimg
            const datetime = new Date(msg.time * 1000)
            const item = {
                conversationID,
                id,
                from,
                random,
                sequence,
                time,
                isRead,
                isPeerRead,
                is_read: false,
                isSend,
                classname: isSend ? 'self' : 'peer',
                msgStyle: ext.msgStyle,
                img: ext.img,
                content: payload.data || payload.text,
                datetime,
                date: formatTime(datetime),
                headimg,
                mini_headimg
            }
            if (item.msgStyle === 'accepted_ask_phone') {
                item.phone = ext.copyText
                item.card = {
                    headimg: mini_headimg,
                    nickname: ext.nickName,
                    msg: item.content,
                }
            }
            if (item.msgStyle === 'building_card') {
                item.content = ext.building
            }
            if (item.msgStyle === 'audio') {
                console.error('ext.audio', ext.audio)
                item.duration = parseInt(ext.audio.duration / 1000)
                item.url = ext.audio.url
            }
            if (item.msgStyle === 'location') {
                item.location = ext
            }
            if (item.msgStyle === 'invite' || item.msgStyle === 'building_price_report') {
                item.building_id = ext.building_id
            }
            if (item.msgStyle === 'layout_image') {
                item.layout_image = ext
            }
            msgs.push(item)
        }
        return msgs
    }, [])
}

const checkNewMsgs = (msg) => {
    const { chatsMap } = IM_STORE
    const new_msgs = handleMessages([msg])
    const chat = chatsMap[msg.conversationID] || {
        msgs: []
    }
    if (chat) {
        const chat_len = chat.msgs.length
        if (new_msgs[0].msgStyle === 'sys_tips') {
            new_msgs[0].show_date = true
        } else if (chat_len) {
            const last_msg = chat.msgs[chat_len - 1]
            const { datetime } = last_msg
            new_msgs[0].show_date = new_msgs[0].datetime - datetime > MAX_DATETIME_SEGMENT
        }
    }
    return new_msgs
}

const timLogin = (userID, userSig) => {
    console.error('-------------------------------------------- tim login --------------------------------------------')
    return tim.login({
        userID,
        userSig
    }).then((res) => {
        console.error(res.data, 'im 登陆成功')
        return res.data
    }).catch((im_err) => {
        console.error(im_err, 'im 登陆失败')
        return {}
    })
}

const timLogout = () => {
    if (IM_STATE.login && IM_STATE.sdk_ready) {
        return tim.logout().then((res) => {
            console.error('logout success')
            IM_STATE.login = false
            return res
        })
    }
    return Promise.resolve('尚未登录 TIM')
}

const receivedMsgHandler = ({ data }) => {
    console.error('-------------message received-------------')
    const { chatsMap } = IM_STORE
    data.forEach((msg) => {
        const { conversationID } = msg
        if (chatsMap[conversationID] && chatsMap[conversationID].msgs instanceof Array) {
            const new_msgs = checkNewMsgs(msg)
            chatsMap[conversationID].msgs.push(...new_msgs)
        }
    })
    IM_STORE.chatsMap = chatsMap
}

const initMsgListener = () => {
    tim.off(TIM.EVENT.MESSAGE_RECEIVED, receivedMsgHandler)
    tim.on(TIM.EVENT.MESSAGE_RECEIVED, receivedMsgHandler)
    tim.on(TIM.EVENT.MESSAGE_READ_BY_PEER, function(event) {
        const { chatsMap } = IM_STORE
        const { data } = event
        data.forEach(({ isPeerRead, conversationID, ID }) => {
            chatsMap[conversationID].msgs.some((msg) => {
                if (msg.id === ID) {
                    msg.isPeerRead = isPeerRead
                    return true
                }
            })
        })
        IM_STORE.chatsMap = chatsMap
    })
}

const login = () => {
    if (IM_STORE.login_loading) {
        return Promise.reject('logining')
    }
    if (IM_STATE.login) {
        return Promise.reject('already login')
    }
    IM_STORE.login_loading = true
    return Service.getSessions({
        page: 1,
        per: 1
    }).then((data) => {
        const { headimgurl, identifier, nickname, user_sign, items } = data
        userInfo = {
            headimgurl,
            nickname,
            user_sign,
            identifier
        }
        timLogin(identifier,  user_sign).then(() => {
            IM_STATE.login = true
            getSessions({
                page: 1
            })
        })
        IM_STORE.login_loading = false
    }).catch((err) => {
        console.error(err)
        IM_STORE.login_loading = false
    })
}

const getSessionContent = (chat) => {
    const { last_messsage } = chat
    if (last_messsage) {
        const { msg_style } = last_messsage
        const MSG_DEFAULT_MAP = {
            building_price_report: '[楼盘价值分析报告]',
            invite: '[邀请看房]',
            img: '[图片]',
            audio: '[语音]',
            building_card: `[${last_messsage.msg_content}]`
        }
        return MSG_DEFAULT_MAP[msg_style] || last_messsage.msg_content
    }
    return ''
}

export const getSessionItem = (item) => {
    const peer_headimgurl = item.peer_headimgurl || DEFAULT_HEADIMG
    return {
        ...item,
        show_content: getSessionContent(item),
        date: item.last_messsage && item.last_messsage.created_time ? item.last_messsage.created_time.substr(5, 11) : '',
        peer_nickname: item.peer_nickname || '用户',
        mini_headimg: peer_headimgurl.indexOf('https://cdn.vip-wifi.com') === 0 ? (peer_headimgurl + '?x-oss-process=image/resize,w_88') : peer_headimgurl
    }
}

const getSessions = (opt = { page: 1 }) => {
    if (IM_STORE.session_loading) {
        return
    }
    const { page } = opt
    if (page === 1) {
        IM_STORE.no_more = false
    }
    console.error('get sessions')
    IM_STORE.session_loading = true

    IM_STORE.page = page

    Service.getSessions({
        page,
        per: IM_PAGE_SIZE
    }).then((data) => {
        const { items } = data
        const new_items = items.map(getSessionItem)
        let { chatList } = IM_STORE
        const checkUnique = (chat_id) => {
            return chatList.every(({ id }) => {
                return id != chat_id
            })
        }
        if (page === 1) {
            chatList = new_items
        } else {
            new_items.forEach((item) => {
                if (checkUnique(item.id)) {
                    chatList.push(item)
                }
            })
        }

        const loaded_page = Math.ceil(IM_STATE.loaded_chat_len / IM_PAGE_SIZE)
        if (loaded_page < page) {
            IM_STATE.loaded_chat_len += new_items.length
        }
        IM_STORE.chatList = chatList
        IM_STORE.no_more = new_items.length === 0 || new_items.length < IM_PAGE_SIZE
        IM_STORE.session_loading = false
        if (IM_STORE.no_more) {
            const messaged_changed = IM_STATE.refresh_timestamp && IM_STATE.message_changed &&
                IM_STATE.message_changed_timestamp > IM_STATE.refresh_timestamp
            if (messaged_changed) {
                IM_STATE.refresh_timestamp = IM_STATE.message_changed_timestamp
                getSessions({
                    page: 1
                })
            } else {
                IM_STATE.refresh_timestamp = new Date().getTime()
            }
        }
    }).catch((err) => {
        console.error(err)
        IM_STORE.session_loading = false
    })
}


const getUnread = (opt = { page: 1, per: 20 }) => {
    const { page, per } = opt
    return Service.getSessions({
        page,
        per,
        status: 'unread'
    }).then((data) => {
        const { items } = data
        return items.map(getSessionItem)
    }).catch((err) => {
        console.error('unread list error', err)
    })
}

let list_inited = false

const listenSessionUpdate = () => {
    tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, (res) => {
        const { data } = res
        const { chatList } = IM_STORE
        const is_changed = (data.length != IM_STORE.chatList.length)
            ||
            data.some((conversation, i) => {
                const chat = chatList[i]
                return conversation.conversationID !== `C2C${chat.peer_identifier}`
                    ||
                    (conversation.unreadCount !== chat.unread_messages_count && conversation.unreadCount > 0)
            })
        console.error('conversation received', res)
        if (is_changed && list_inited) {
            IM.checkUnread()
        }
        if (is_changed) {
            getSessions({
                page: 1
            })
        } else {
            IM_STATE.message_changed = true
            IM_STATE.message_changed_timestamp = new Date().getTime()
        }
        if (!list_inited) {
            list_inited = true
        }
    })
}

const getMessages = (conversationID) => {
    const getMessageList = () => {
        const params = {
            conversationID,
            count: 15
        }
        const { chatsMap } = IM_STORE
        const chat = chatsMap[conversationID]
        params.nextReqMessageID = chat && chat.nextReqMessageID ? chat.nextReqMessageID : ''
        console.error('get messages', params)
        return tim.getMessageList(params).then(({ data }) => {
            const { messageList, nextReqMessageID } = data
            const { chatsMap } = IM_STORE
            const handledMessageList = handleMessages(messageList)
            let prev_datetime = 0
            handledMessageList.forEach((msg) => {
                const { datetime } = msg
                msg.show_date =  msg.msgStyle === 'sys_tips' || !prev_datetime || datetime - prev_datetime >= MAX_DATETIME_SEGMENT
                prev_datetime = datetime
            })
            if (!chatsMap[conversationID]) {
                chatsMap[conversationID] = {
                    msgs: []
                }
            }
            chatsMap[conversationID].msgs = handledMessageList.concat(chatsMap[conversationID].msgs)
            chatsMap[conversationID].nextReqMessageID = nextReqMessageID
            IM_STORE.chatsMap = chatsMap
            return handledMessageList
        })
    }
    if (IM_STATE.sdk_ready) {
        return getMessageList()
    }
    return new Promise((res) => {
        tim.on(TIM.EVENT.SDK_READY, () => {
            IM_STATE.sdk_ready = true
            getMessageList().then(res)
        })
    })
}

const resetChatMapByConversation = () => {
    const { chatsMap } = IM_STORE
    Object.keys(chatsMap).forEach((key) => {
        delete chatsMap[key]
    })
    IM_STORE.chatsMap = chatsMap
}

const getFrom = () => {
    const pages = getCurrentPages().filter(v => v && v.route)
    if (pages && pages.length >= 2) {
        const routes = []
        if (pages.length >= 3) {
            routes.push(pages[pages.length - 3].route)
        }
        routes.push(pages[pages.length - 2].route)
        return routes.map((route) => PAGE_TO_KEY[route] || route).join(',')
    }
    return ''
}

const createTextMsg = (to, content, data) => {
    if (!IM_STATE.sdk_ready) {
        return Promise.reject()
    }
    return tim.createCustomMessage({
        to,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
            data: content,
            extension: JSON.stringify(data)
        }
    })
}

const creatReportMsg = (to, content, building_id, data) => {
    if (!IM_STATE.sdk_ready) {
        return Promise.reject()
    }

    return tim.createCustomMessage({
        to,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
            data: content,
            extension: JSON.stringify({
                ...data,
                building_id,
                msgStyle: 'building_price_report'
            })
        }
    })
}

const creatStickerMsg = (to, img, name, data) => {
    if (!IM_STATE.sdk_ready) {
        return Promise.reject()
    }

    return tim.createCustomMessage({
        to,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
            data: name,
            description: 'sticker',
            extension: JSON.stringify({
                ...data,
                img,
                msgStyle: 'sticker'
            })
        }
    })
}

const createImgMsg = (to, img, data) => {
    if (!IM_STATE.sdk_ready) {
        return Promise.reject()
    }

    return tim.createCustomMessage({
        to,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
            data: img,
            description: 'img',
            extension: JSON.stringify({
                ...data,
                img,
                msgStyle: 'img'
            })
        }
    })
}

const createAudioMsg = (to, audio, data) => {
    if (!IM_STATE.sdk_ready) {
        return Promise.reject()
    }
    console.error('create audio msg', audio)

    return tim.createCustomMessage({
        to,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
            data: audio.url,
            description: 'audio',
            extension: JSON.stringify({
                ...data,
                audio,
                msgStyle: 'audio'
            })
        }
    })
}

const createBuildingCardMsg = (to, building, data) => {
    if (!IM_STATE.sdk_ready) {
        return Promise.reject()
    }

    console.error(data)
    return tim.createCustomMessage({
        to,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
            data: building.name,
            description: 'building_card',
            extension: JSON.stringify({
                ...data,
                building,
                msgStyle: 'building_card'
            })
        }
    })
}

const createInviteCardMsg = (to,building_id) => {
    if (!IM_STATE.sdk_ready) {
        return Promise.reject()
    }
    return tim.createCustomMessage({
        to,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
            description: 'invite_card',
            extension: JSON.stringify({
                building_id,
                msgStyle: 'invite'
            })
        }
    })
}

const createLocationMsg = (to, location) => {
    if (!IM_STATE.sdk_ready) {
        return Promise.reject()
    }
    console.error(location)
    return tim.createCustomMessage({
        to,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
            data: location.name,
            description: 'location_msg',
            extension: JSON.stringify({
                ...location,
                msgStyle: 'location'
            })
        }
    })
}

const sendMsg = async (msg, check_sensitive = true) => {
    if (!IM_STATE.sdk_ready) {
        return Promise.reject('SDK not ready')
    }
    const { chatsMap } = IM_STORE
    const new_msgs = checkNewMsgs(msg)
    const chat = chatsMap[msg.conversationID] || {
        msgs: []
    }
    chat.msgs.push(...new_msgs)
    IM_STORE.chatsMap = chatsMap
    const { data } = msg.payload
    if (check_sensitive) {
        const removeSensitiveMsg = () => {
            chat.msgs.some(({ id }, i) => {
                if (msg.ID === id) {
                    chat.msgs.splice(i, 1)
                    return true
                }
            })
            IM_STORE.chatsMap = chatsMap
        }
        const check_rs = await PublicService.checkWords(data)
        console.log('check_rs', check_rs)
        if (check_rs && check_rs.items && check_rs.items.length) {
            removeSensitiveMsg()
            wx.showToast({
                title: '内容含有敏感信息',
                icon: 'none'
            })
            return Promise.reject('has sensitive words')
        }
    }
    return tim.sendMessage(msg)
}

const readMsg = (session_id, newMsgs) => {
    if (newMsgs.length) {
        newMsgs = newMsgs
            .filter((msg) => !msg.isSend)
            .map(({ from, random, sequence, time, id, conversationID }) => ({
                conversationID,
                id,
                from_account: from,
                msg_random: random,
                msg_seq: sequence,
                msg_time: time
            }))
        const { chatsMap } = IM_STORE
        newMsgs.forEach(({ conversationID, id }) => {
            const chat_store = chatsMap[conversationID]
            if (chat_store) {
                const { msgs } = chat_store
                msgs.forEach((msg) => {
                    if (id === msg.id) {
                        msg.is_read = true
                    }
                })
            }
        })
        IM_STORE.chatsMap = chatsMap
        newMsgs.forEach((msg) => {
            const { conversationID, id } = msg
            if (IM_STATE.sdk_ready) {
                tim.setMessageRead({
                    conversationID
                })
            }
        })
        return
    }
    Service.readTimSession(session_id)
}

const TimSendMsg = (msg) => {
    tim.sendMessage(msg)
}

const checkUnread = () => {
    App_User.fetchUser().then(({ unread_tim_messages_count }) => {
        IM_STORE.show_unread = unread_tim_messages_count > 0
    })
}

const readAudioMsg = (msg) => {
    const { from, random, sequence, time, id, conversationID, msgStyle } = msg
    const new_msg = {
        conversationID,
        id,
        msgStyle,
        from_account: from,
        msg_random: random,
        msg_seq: sequence,
        msg_time: time
    }
    const { chatsMap } = IM_STORE
    const { msgs } = chatsMap[conversationID]
    msgs.forEach((item) => {
        if (item.id === id) {
            item.is_read = true
            item.isRead = true
        }
    })
    IM_STORE.chatsMap = chatsMap
    if (IM_STATE.sdk_ready) {
        tim.setMessageRead({
            conversationID,
            messageID: id
        })
    }
    Service.readTimMsg([msg])
}

const readAll = () => {
    IM_STORE.show_unread = false
    tim.getConversationList().then(({ data }) => {
        data.conversationList.forEach(({ conversationID, unreadCount }) => {
            if (unreadCount) {
                tim.setMessageRead({
                    conversationID
                })
            }
        })
    })
}

const delChat = (id) => {
    return Service.delTimMsg(id).then(() => {
        const { chatList } = IM_STORE
        chatList.some((chat, i) => {
            if (chat.id === id) {
                tim.setMessageRead({
                    conversationID: `C2C${chat.peer_identifier}`
                })
                chatList.splice(i, 1)
                IM_STORE.chatList = chatList
                return true
            }
        })
    })
}
const setChatTop = (id, params) => {
    Service.setTimTop(id, params)
    const { chatList } = IM_STORE
    for (let i = 0; i < chatList.length; i++) {
        const chat = chatList[i]
        if (chat.id === id) {
            const { topped } = params
            chat.topped = topped
            chatList.splice(i, 1)
            if (topped) {
                chatList.unshift(chat)
            } else {
                chatList.push(chat)
            }
            IM_STORE.chatList = chatList
            return
        }
    }
}
const readChat = (id) => {
    const { chatList } = IM_STORE
    chatList.some((chat, i) => {
        if (chat.id === id) {
            chat.unread_messages_count = 0
            IM_STORE.chatList = chatList
            return true
        }
    })
}

const destroy = () => {
    console.error('invoke destroy')
    IM_STATE.login = false
    IM_STORE.login = LOGIN_STATUS.NONE
    return tim.destroy().catch((imError) => {
        console.warn('destroy error:', imError)
    })
}

const setBlock = (id, params) => {
    return Service.setBlockStatus(id, params).then((res)=> {
        return res
    })
}

const IM = {
    setChatTop,
    login,
    initIM,
    logout: timLogout,
    destroy,
    getSessions,
    getUnread,
    checkUnread,
    getMessages,
    createTextMsg,
    createImgMsg,
    createAudioMsg,
    createBuildingCardMsg,
    sendMsg,
    readMsg,
    delChat,
    readChat,
    resetChatMapByConversation,
    readAll,
    readAudioMsg,
    setBlock,
    TimSendMsg,
    creatReportMsg,
    creatStickerMsg,
    createLocationMsg,
    createInviteCardMsg
}

export default IM
